export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/products/state.js